import React from 'react';
import Select from '@material-ui/core/Select';
import { Box, MenuItem, Button, FormControl } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 40,
    paddingRight: '20px'
  },
  orderIncDecBtnRoot: {
    minWidth: 'fit-content'
  },
  cartSelect: {
    height: '28px'
  }
}));

const QuantitySelect = function (props) {
  const [open, setOpen] = React.useState(false);
  const classes = useStyles();

  const handleChange = (event) => {
    props.item.quantity = event.target.value;
    props.updateCart(props.item, event.target.value);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const numArr = Array.from(Array(100).keys());

  return (
    <Box className={classes.formControl}>
      <Select
        className={classes.cartSelect}
        variant="outlined"
        id="name"
        labelId="controlled-open-select-label"
        onChange={handleChange}
        onClose={handleClose}
        onOpen={handleOpen}
        open={open}
        value={props.item.quantity}>
        {numArr.map((numb, i) => {
          return (
            <MenuItem key={`quantity_${i}`} value={numb}>
              {numb}
            </MenuItem>
          );
        })}
      </Select>
    </Box>
  );
};

export default QuantitySelect;
